export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

interface Props {
    year?: string | null
    month?: string | null
}

export default class extends Component<Props> {
    static template = template;
    static defaults() {
        return {
            year: null,
            month: null,
        } as Props;
    }
}